import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ce21da4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4ce21da4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce21da4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce21da4')) {
      api.createRecord('4ce21da4', component.options)
    } else {
      api.reload('4ce21da4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ce21da4&scoped=true&", function () {
      api.rerender('4ce21da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common-page/leader-about/index.vue"
export default component.exports